var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"vc-nav-arrow-icon",attrs:{"viewBox":_vm.viewBox,"width":"20","height":"24","aria-hidden":"true"}},[_c('path',{attrs:{"fill":"currentColor","d":_vm.path}})])}
var staticRenderFns = []

export { render, staticRenderFns }